import { Injectable } from '@angular/core';

@Injectable()
export class PrivacyPolicyService {

  public static PRIVACY_POLICY_KEY = 'privacy_policy';

  constructor() {
  }

  save(status) {
    localStorage.setItem(PrivacyPolicyService.PRIVACY_POLICY_KEY, status);
  }

  getStatus() {
    let item = localStorage.getItem(PrivacyPolicyService.PRIVACY_POLICY_KEY);
    if(item && item === 'true') {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/main/privacy-policy/privacy-policy.service.ts